import gql from 'graphql-tag';

export const GET_DEALER_ACCOUNT = gql`
  query GetDealerAccount($dynamicsId: ID) {
    publicAccount(dynamicsId: $dynamicsId) {
      id
      dynamicsAccountId
      name
      contacts {
        id
        fullName
        email
        phoneNumber
        vendorContactRole
        title
        status
        dynamicsContactId
      }
      locations {
        locationId
        locationName
        category
        locationParentName
        ocaContact {
          id
          fullName
        }
        childrenLocation {
          locationId
          locationName
        }
      }
      vendorProfile {
        logo
      }
    }
  }
`;
